export default [
    {
        value: "Nacional",
        text: "Nacional"
    },
    {
        value: "Internacional",
        text: "Internacional"
    },
]